import React from "react";
import { Row, Col } from "react-bootstrap";

export default () => {
  return (
    <div className="bottom-tab">
      <Row>
        <Col xs="4">
          <a
            href="https://play.google.com/store/apps/details?id=com.c2info.wellnessforever"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + "/image/icon-11.svg"} alt="" />
          </a>
        </Col>
        <Col xs="4">
          <a
            href="https://api.whatsapp.com/send/?phone=919920109090&text&app_absent=0"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + "/image/icon-12.svg"} alt="" />
          </a>
        </Col>
        <Col xs="4">
          <a
            href="https://wellnessforever.com"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + "/image/icon-13.svg"} alt="" />
          </a>
        </Col>
      </Row>
    </div>
  );
};
